import { useEffect } from "react";

interface Props {
  id: string;
  data: unknown | null | undefined;
}

/** Injeta (e remove) um bloco JSON-LD no <head> de forma idempotente. */
const JsonLd = ({ id, data }: Props) => {
  useEffect(() => {
    if (!data) return;
    const scriptId = `ld-${id}`;
    document.getElementById(scriptId)?.remove();
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = scriptId;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);
    return () => {
      document.getElementById(scriptId)?.remove();
    };
  }, [id, data]);

  return null;
};

export default JsonLd;
